import React from "react";
import { Grid, Typography, Button } from "@mui/material";
import { GppGoodOutlined } from "@mui/icons-material";
import moment from "moment";
import "moment/locale/fr";
moment.locale("fr");

function Annulation({ page, setPage }) {
    return (
    <Grid container mt="50px" direction="column">
      <Grid container item justifyContent={"center"}>
        <GppGoodOutlined sx={{ fontSize: "5em", color: "#5ACA2E" }} />
        <Typography variant="h3" component="h1" align="center">
          Annulation
        </Typography>
      </Grid>
      <Grid container item justifyContent={"center"}>
        <Typography variant="h4" component="h2" align="center">
          Votre Rendez-vous n'a pas été confirmé, le créneau est toujours disponible.
        </Typography>
      </Grid>
      <Grid container item justifyContent={"center"} mt={6}>
        <Button
          // style={{ textTransform: "none" }}
          variant="contained"
          onClick={() =>
            setPage({
              ...page,
              page: 0,
              place: null,
              motif: null,
              praticien: null,
              date: "",
              valid: false,
              patient: {
                nom: "",
                prenom: "",
                email: "",
                tel: "",
              },
              smsConfirmation: false,
              smsGuid: "",
            })
          }
        >
          Revenir à l'accueil
        </Button>
      </Grid>
    </Grid>
  );
}

export default Annulation;
